export default __webpack_public_path__ + "static/media/icon_market.05f6ef86.svg";